import { Box, IconButton, useColorModeValue } from "@chakra-ui/react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { usePlatformSidebar, SIDEBAR_EXPANDED_WIDTH, SIDEBAR_COLLAPSED_WIDTH } from "./PrivateSidebarContext";

interface PrivateSidebarLayoutProps {
  children: React.ReactNode;
}

const PrivateSidebarLayout: React.FC<PrivateSidebarLayoutProps> = ({ children }) => {
  const sidebarBg = useColorModeValue("gray.50", "gray.600");
  const toggleBg = useColorModeValue("white", "gray.800");
  const toggleHoverBg = useColorModeValue("gray.100", "gray.700");
  const { isCollapsed, toggleSidebar } = usePlatformSidebar();

  const width = isCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_EXPANDED_WIDTH;

  return (
    <Box
      as="aside"
      position="fixed"
      top="69px"
      width={`${width}px`}
      height="calc(100vh - 69px)"
      bg={sidebarBg}
      borderWidth={1}
      borderColor="gray.400"
      boxShadow="lg"
      transition="width 0.25s ease"
      overflowY="auto"
      overflowX="hidden"
      zIndex={10}
    >
      <IconButton
        aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        icon={isCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
        size="md"
        borderRadius="full"
        position="absolute"
        top="2px"
        right="-12px"
        zIndex={20}
        boxShadow="md"
        bg={toggleBg}
        _hover={{ bg: toggleHoverBg }}
        onClick={toggleSidebar}
      />
      {children}
    </Box>
  );
};

export default PrivateSidebarLayout;